import { CartItem } from "./CartItem";
import type { CartItem as CartItemType } from "@/lib/shopify";

interface CartItemsListProps {
  items: CartItemType[];
  onUpdateQuantity: (variantId: string, quantity: number) => void;
  onRemove: (variantId: string) => void;
}

export const CartItemsList = ({ items, onUpdateQuantity, onRemove }: CartItemsListProps) => {
  return (
    <div className="flex-1 overflow-y-auto pr-2 min-h-0">
      <div className="space-y-4" role="list" aria-label="Shopping cart items">
        {items.map((item) => (
          <CartItem
            key={item.variantId}
            item={item}
            onUpdateQuantity={onUpdateQuantity}
            onRemove={onRemove}
          />
        ))}
      </div>
    </div>
  );
};
